import {
    Box,
    Button,
    Center,
    Menu,
    MenuButton,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Stack,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    useDisclosure
} from "@chakra-ui/react";
import React, { useState } from "react";
import { MdCheck, MdDelete, MdSettings } from "react-icons/md";
import { Link } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import {
    AccountSubscriptionsDocument,
    GetSubscriptionsThatNeedReviewDocument,
    InsurancePolicyHolderSubscriptionAuthorization,
    useApproveSubscriptionsThatNeedReviewMutation,
    useDeleteSubscriptionsThatNeedReviewMutation,
    useGetSubscriptionsThatNeedReviewQuery
} from "../../graphql";
import { formatDate } from "../../utils";
import {
    SubscriptionInfo,
    getSubscriptionMethod
} from "../Subscription/subscription";

export const SubscriptionsNeedReview: React.FC = () => {
    const [
        approveSubscription,
        { loading: loadingApprove }
    ] = useApproveSubscriptionsThatNeedReviewMutation();
    const [
        deleteSubscription,
        { loading: loadingDelete }
    ] = useDeleteSubscriptionsThatNeedReviewMutation();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [currentItem, setCurrentItem] = useState<number>();

    const { loading, data } = useGetSubscriptionsThatNeedReviewQuery();

    const handleApproveSubscription = async (id: number) => {
        await approveSubscription({
            variables: {
                id: id
            },
            refetchQueries: [
                {
                    query: GetSubscriptionsThatNeedReviewDocument
                },
                {
                    query: AccountSubscriptionsDocument,
                    variables: {
                        page: 1,
                        pageLimit: 100
                    }
                }
            ]
        });

        onClose();
    };

    const handleDeleteSubscription = async (id: number) => {
        await deleteSubscription({
            variables: {
                id: id
            },
            refetchQueries: [
                {
                    query: GetSubscriptionsThatNeedReviewDocument
                },
                {
                    query: AccountSubscriptionsDocument,
                    variables: {
                        page: 1,
                        pageLimit: 100
                    }
                }
            ]
        });

        onClose();
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <Modal
                closeOnOverlayClick={ false }
                isOpen={ isOpen }
                onClose={ onClose }
                size="xl"
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Menaxho aplikimin</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody border={ 0 }>
                        <SubscriptionInfo id={ currentItem } />
                        <Center>
                            <Stack direction="row" spacing={ 4 } m={ 4 }>
                                <Button
                                    leftIcon={ <MdCheck /> }
                                    colorScheme="green"
                                    variant="solid"
                                    onClick={ () => handleApproveSubscription(currentItem) }
                                    isLoading={ loadingApprove }
                                >
                                    Aprovo
                                </Button>
                                <Button
                                    leftIcon={ <MdDelete /> }
                                    colorScheme="red"
                                    variant="solid"
                                    onClick={ () => handleDeleteSubscription(currentItem) }
                                    isLoading={ loadingDelete }
                                >
                                    Fshi
                                </Button>
                            </Stack>
                        </Center>
                    </ModalBody>
                </ModalContent>
            </Modal>
            <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
                <Title title="Lista e abonimeve që kërkojnë aprovim"></Title>

                <Table variant="striped" size="sm" marginTop="15px">
                    <Thead>
                        <Tr>
                            <Th>Klienti</Th>
                            <Th>Paketa</Th>
                            <Th>Fillimi</Th>
                            <Th>Përfundimi</Th>
                            <Th>Statusi</Th>
                            <Th>Metoda</Th>
                            <Th>Polica</Th>
                            <Th>Kodi</Th>
                            { /* <Th>Telefonuesi</Th>
              <Th>Të ftuar</Th>
              <Th>Statusi</Th>
              <Th>Data</Th>
              <Th>Kohëzgjatja</Th> */ }
                        </Tr>
                    </Thead>
                    <Tbody>
                        { data?.getSubscriptionsThatNeedReview.nodes.map((item) => {
                            // const participants = call.participants;

                            return (
                                <Tr key={ item.id }>
                                    <Td>
                                        <Link to={ `/subscription/${item.id}` }>
                                            { item?.account ? (
                                                <AccountAvatar
                                                    key={ item?.account?.id }
                                                    account={ item?.account }
                                                    size="xs"
                                                    role={ false }
                                                />
                                            ) : null }
                                        </Link>
                                    </Td>
                                    <Td>{ item.tier.name }</Td>
                                    <Td>{ formatDate(item.startDate) }</Td>
                                    <Td>{ formatDate(item.expirationDate) }</Td>
                                    <Td>{ item.isActive ? "Aktive" : "Jo aktive" }</Td>
                                    <Td>{ getSubscriptionMethod(item.authorization) }</Td>
                                    <Td>
                                        {
                      (item.authorization as InsurancePolicyHolderSubscriptionAuthorization)
                          .insurancePolicy?.name
                                        }
                                    </Td>
                                    <Td>
                                        {
                                            (item.authorization as InsurancePolicyHolderSubscriptionAuthorization)
                                                .insurancePolicySerialNumber
                                        }
                                    </Td>
                                    <Td isNumeric>
                                        <Menu>
                                            <MenuButton
                                                px={ 2 }
                                                py={ 0.5 }
                                                transition="all 0.2s"
                                                _focus={ { boxShadow: "outline" } }
                                                onClick={ () => {
                                                    setCurrentItem(item.id);
                                                    onOpen();
                                                } }
                                            >
                                                <MdCheck />
                                            </MenuButton>
                                        </Menu>
                                    </Td>
                                </Tr>
                            );
                        }) }
                    </Tbody>
                </Table>
            </Box>
        </>
    );
};
